import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const ListingBuyerSurveyRequired = union([
    literal('yes'),
    literal('no'),
    literal('unknown'),
]);
